import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { NCZIEntry } from '../../../Interfaces/ncziTypes';
import { Size } from '../../../../../Enums/Size.enum';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import ElectronicDPNDetailModalContent from './ElectronicDPNDetailModalContent';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	patientIdentifier: string;
	electronicConfirmation: NCZIEntry;
	readonly: boolean;
	disableCreate?: boolean;
}

const ElectronicDPNDetailModal: React.FC<Props> = props => {
	const {
		opened,
		onClose,
		patientIdentifier,
		electronicConfirmation,
		readonly = false,
		disableCreate = false,
	} = props;

	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			fullScreen={false}
			size={Size.SM}
			wrapChat={isCase}>
			<Modal.Header title='nczi.electronicDPN.detail.title' firstUpper />
			<Modal.Content>
				<ElectronicDPNDetailModalContent
					onClose={onClose}
					patientIdentifier={patientIdentifier}
					electronicConfirmation={electronicConfirmation}
					readonly={readonly}
					disableCreate={disableCreate}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicDPNDetailModal;
